import styled from 'styled-components';

export const StyledLandingContainer = styled.div`
    max-width: 1160px;
    margin: 0 auto;

    @media (max-width: 1352px) {
        margin: 0 96px;
    }

    @media (max-width: 1024px) {
        margin: 0 48px;
    }
`;

export const StyledContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 64px;
    padding: 32px 0;
`;

export const StyledHeaderContainer = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    height: 76px;
`;
